import { Component, OnInit } from '@angular/core';
import { SelectItem, MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EmailInfo, MspPaymentSetting } from '../../../my-features/region/region.model';
import { planMailRecipientType, planMailRecipientTypeName, updateInfoType, DocumentTypeName, DefaultMinimumQuantity, PrepaidUnitPrice } from '../../../shareModel';
import {UpdateInfoModel} from '../../../my-features/updateInfo/update-info.model';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as fromFeature from '../../../my-features';
import { PreferenceService } from '../../../services/preference.service';
import { CryptoService } from '../../../services/crypto.service';
import { Router } from '@angular/router';
import { RegionService } from 'src/app/services/region.service';

@Component({
  standalone: false,
  selector: 'app-payment-mgt-list',
  templateUrl: './payment-mgt-list.component.html',
  styleUrls: ['./payment-mgt-list.component.css']
})
export class PaymentMgtListComponent implements OnInit {
  private componentDestroyed = new Subject();
  monthlyPaymentTable_cols: any[] = [
    { field: 'Company', header: 'Company', width: '220', class: 'col-nowrap', disabled: false  },
    { field: 'IsDistributor', header: '', width: '80', class: 'col-nowrap', disabled: true  },
    { field: 'Region', header: 'Region', width: '200', class: 'col-nowrap', disabled: false  },
    { field: 'UnitPrice', header: 'Unit Price (USD)', width: '150', class: 'col-nowrap', disabled: false  },
    { field: 'Nodes', header: 'NPM Bank', width: '150', class: 'col-nowrap', disabled: false, frozenRight: true  },
    { field: 'DocumentCreateTime', header: 'Last Billing Generate Date', width: '220', class: 'col-nowrap', disabled: false, frozenRight: true  }
  ];
  monthlyPaymentList = [];
  paymentList = [];
  region_filter_Dic = [];
  regionDic = [];
  currentUser: any;
  selectedNode = null;
  isSystemAdmin = false;
  isAdmin = false;
  isMsp = false;
  // regionOptions$: Observable<any>;
  regionOptions: SelectItem[];
  UpdateInfoParam = {} as UpdateInfoModel;
  filterRegion = {
    RegionIds: [],
    RegionIdForRecord: 0
  };
  getMspRegionParam = {
    otp: '',
    RegionId: []
  };
  getMspDeviceUsageParam = {
    otp: '',
    RegionId: 0,
    IsDistributorAll: false
  };
  recipientList: EmailInfo[] = [];
  recipientOptions: any = [
    { label: 'Main Recipient', value: 0 },
    { label: 'CC', value: 1 },
    { label: 'BCC', value: 2 },
  ];
  documentOptions: any = [
    { label: 'PO', value: 0 },
    { label: 'Invoice', value: 1 },
  ];
  customerOptions_all: any = [];
  customerOptions: any = [];
  mailRecipientMap = planMailRecipientType;

  dialogVisibility = {
    monthlyPayment: false,
    recipient: false,
    confirm: false,
    documentGenerate: false,
  };

  dialogInput = {
    // DocType: 0,
    // DocDay: 0,
    RegionId: 0,
    IsDistributor: false,
    IsCustomer: false,
    IsEndUser: false,
    Customers: [],
    UnitPrice: '',
    CompanyName: '',
    Address: '',
    MinCharge: '',
    CompanyEmail: '',
    SyncSetting: false,
    IsNotSendReminder: true,
    IsNotAllowLock: true,
    NpmUsageType: 0,
  };

  dialogRecipientInput = {
    Id: 0,
    UpdateType: '',
    Receiver: 'string',
    ReceiverType: 0,
    Type: 0 // 0(add), 1(edit)
  };

  recipient_main: string;
  recipient_cc: string;
  recipient_bcc: string;
  isMspLoaded = false;
  inheritDialog = false;
  customers = [];
  customers_str = '';
  dcoumentType_name = '';
  isDistributor_Display = '';
  update_payment_flag = false;
  treeRegionPayment: any[] ;
  treeRegionPaymentStash: any[] ;
  keyWord: string;
  monthlyPaymentListStash = [];

  npmUsageOptions: SelectItem[] = [
    { label: 'Deduct from distributor\'s NPM bank', value: 0 },
    { label: 'Deduct from customer\'s NPM bank   ', value: 1 },
  ];

  paymentRecordList = [];
  paymentRecordListFiltered = [];
  paymentRecordTable_cols: any[] = [
    { field: 'DocNo', header: 'PO No.', width: '150', class: 'col-nowrap' },
    { field: 'Company', header: 'Company', width: '220', class: 'col-nowrap' },
    { field: 'DocType', header: 'Document Type', width: '180', class: 'col-nowrap' },
    { field: 'PaymentUsage', header: 'Quantity (NPM)', width: '180', class: 'col-nowrap' },
    { field: 'UnitPrice', header: 'Unit Price', width: '180', class: 'col-nowrap' },
    { field: 'TotalPrice', header: 'Total', width: '180', class: 'col-nowrap' },
    { field: 'GenerateTime', header: 'Generate Time', width: '180', class: 'col-nowrap', frozenRight: true },
    { field: 'CreateAccount', header: 'Created by', width: '220', class: 'col-nowrap', frozenRight: true }
  ];
  companyOptions: any = [];
  selectedCompany = [];
  yearOptions: any = [];
  selectedYears = [];
  selectDefaultTab: number;

  constructor(private ngxService: NgxUiLoaderService, private store: Store<fromStore.State>,
    public preferenceService: PreferenceService, private cryptoService: CryptoService,
    private router: Router, private messageService: MessageService, private regionService: RegionService ) {

    this.monthlyPaymentList = [];
    this.store.dispatch(new fromFeature.ReadMspPaymentDocumentList({}));

    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (
        res.type === updateInfoType.UpdateMspPaymentSetting
      ) {
        if (!res.isLoading && res.isLoaded && res.isSaved) {
          this.messageService.add({ severity: 'success', summary: 'Update Success' });
          this.update_payment_flag = true;
          this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getMspRegionParam }));
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          this.messageService.add({ severity: 'error', summary: 'Update Fail' });
        }
        this.resetUpdateInfoState();
      }
      this.ngxService.stop();
    });

    combineLatest(this.store.select(fromStore.getIsMsp),
    this.store.select(fromStore.getCurrentUser))
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getIsMspRes, getCurrentUserRes]) => {
      if (!this.isMspLoaded) {
        this.ngxService.start();
      }
      if ((getIsMspRes !== undefined && getIsMspRes !== null) &&
      (getCurrentUserRes !== undefined && getCurrentUserRes !== null)) {
        this.currentUser = getCurrentUserRes;
        this.isSystemAdmin = getCurrentUserRes.authority === 2;
        this.isAdmin = getCurrentUserRes.authority === 1;
        this.isMsp = getIsMspRes;
        if (getIsMspRes && getCurrentUserRes.authority === 1) {
          this.router.navigate(['/dashboard']);
        }
        if (!this.isSystemAdmin && this.isAdmin && !this.isMsp) {
          this.getMspRegionParam = {
            ...this.getMspRegionParam,
            RegionId: [getCurrentUserRes.RegionId],
          };
        }
        // NgRx 9 不可變性: 創建新對象副本
        this.getMspDeviceUsageParam = { ...this.getMspDeviceUsageParam, RegionId: getCurrentUserRes.RegionId };
        this.isMspLoaded = true;
        this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getMspRegionParam }));
        this.store.dispatch(new fromFeature.ReadMspDeviceUsageList({ ...this.getMspDeviceUsageParam }));
        this.ngxService.stop();
      }
    });

    this.store.select(fromStore.getMspRegionPaymentWithDeviceUsage).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      this.ngxService.start();
      if ((res !== undefined && res !== null)) {
        this.monthlyPaymentList = [];
        this.customerOptions_all = [];
        this.region_filter_Dic = [];
        this.paymentList = Array.isArray(res.payment_list) ? res.payment_list.map((i) => ({ ...i })) : [];
        const payment_dic = [];
        const regionOption_list = [];
        const regionOption_ids = [];
        this.regionDic = res.region_dic ? { ...res.region_dic } : res.region_dic;
        [...this.paymentList].sort(function (a: any, b: any) {
          const companyCompare = a.Company.localeCompare(b.Company, 'en', { sensitivity: 'base' });
          if (companyCompare !== 0) return companyCompare;
          if (a.RegionId < b.RegionId) return -1;
          if (a.RegionId > b.RegionId) return 1;
          if (a.RegionId === b.RegionId) {
            if (new Date(a.DocumentCreateTime).getTime() > new Date(b.DocumentCreateTime).getTime()) return -1;
            if (new Date(a.DocumentCreateTime).getTime() < new Date(b.DocumentCreateTime).getTime()) return 1;
          }
          return 0;
        }).map((m)=> {
          if (this.region_filter_Dic[m.RegionId] === undefined) {
            this.region_filter_Dic[m.RegionId] = [];
            this.region_filter_Dic[m.RegionId].push(m);
          } else {
            this.region_filter_Dic[m.RegionId].push(m);
          }
          if (res.region_dic[m.RegionId] !== undefined) {
            if (regionOption_list !== undefined && regionOption_list.length > 0) {
              if (!regionOption_ids.includes(m.RegionId)) {
                regionOption_ids.push(m.RegionId);
                regionOption_list.push({label: res.region_dic[m.RegionId].RegionName, value: m.RegionId})
              }
            } else {
              regionOption_ids.push(m.RegionId);
              regionOption_list.push({label: res.region_dic[m.RegionId].RegionName, value: m.RegionId})
            }
          }
          payment_dic[m.MspRegionId] = m;
        });
        res.region_dic.map((s) => {
          if (s.IsMsp && s.MspMainRegionId === s.Id) {
            if (this.region_filter_Dic[s.ParentRegionId] !== undefined) {
              if (payment_dic[s.Id] !== undefined) {
                this.customerOptions_all.push({
                  label: s.RegionName , value: {RegionId: s.ParentRegionId, MspRegionId: s.Id, IsDistributor: payment_dic[s.Id].IsDistributor }
                });
              } else {
                this.customerOptions_all.push({
                  label: s.RegionName , value: {RegionId: s.ParentRegionId, MspRegionId: s.Id }
                });
              }
            }
          }
        });

        this.regionOptions = regionOption_list;
        if (!this.isMsp && this.isAdmin) {
          this.filterRegion.RegionIds = [];
          this.filterRegion.RegionIds.push(this.currentUser.RegionId);
        }
        if (this.filterRegion.RegionIds.length > 0) {
          this.filter_region();
        } else {
          this.monthlyPaymentList = res.payment_list.map(item => {
            const customers_name = [];
            const children = [];
            if (item.Customers !== undefined && item.Customers.length > 0) {
              item.Customers.map((c) => {
                if (c !== undefined && this.regionDic[c.value.Id] !== undefined) {
                  customers_name.push(this.regionDic[c.value.Id].RegionName);
                }
              });
            }

            return {
                ...item,
                Customers_Str: customers_name.join('/ '),
                children: children
            };
          });

          this.monthlyPaymentListStash = this.monthlyPaymentList;
          this.getTreeRegionPayment();
        }

        this.ngxService.stop();
      }
    });

    this.store.select(fromStore.getMspPaymentDocumentList).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res !== undefined) {
        this.ngxService.start();
        const companyOptions_list = [];
        const companys = [];
        res.doc_List.map(item =>{
          if (!companys.includes(item.Company)) {
            companys.push(item.Company);
            companyOptions_list.push({label: item.Company, value: item.Company});
          }
        });
        this.companyOptions = companyOptions_list;
        this.paymentRecordList = [...res.doc_List].sort(function (a: any, b: any) {

          if (a.DocId > b.DocId) { return -1; }
          if (a.DocId < b.DocId) { return 1; }
          if (a.DocId === b.DocId) {
            if (new Date(a.DocDate).getTime() > new Date(b.DocDate).getTime()) { return -1; }
            if (new Date(a.DocDate).getTime() < new Date(b.DocDate).getTime()) { return 1; }
          }
          return 0;
        }).map(item => {
          const cryptoDocId = this.cryptoService.aesEncrypt(item.DocId);
          const docType_Name = DocumentTypeName[item.DocType];
          return {
              ...item,
              CryptoDocId: cryptoDocId,
              DocType_Name: docType_Name,
              // IsFree: item.DocType === 1 ? true : false,
              // IsConfirmed: item.DocType === 1 ? true : false,
              // PurchaseType: item.DocType,
          };
        });

        this.paymentRecordListFiltered = this.paymentRecordList;
        
        this.getDefaultDate();
        this.ngxService.stop();
      }
    });

    this.filter_record();
  }

  ngOnInit() {
  }

  showEditDialog() {
    this.selectDefaultTab = 0;
    const customers = this.selectedNode.data.Customers !== undefined ? this.selectedNode.data.Customers.map((c) => {
      return c.value.Id;
    }) : [];
    const customers_pick = [];
    this.customerOptions = [];
    this.monthlyPaymentList.map((m) => {
      if (m.RegionId == this.selectedNode.data.RegionId &&  m.Customers !== undefined && m.Customers.length > 0) {
        m.Customers.map((c) => {
          if (c !== undefined && this.regionDic[c.value.Id] !== undefined) {
            customers_pick.push(c.value.Id);
          }
        });
      }
    });
    this.customerOptions_all.map((c) => {
      if (c.value.RegionId == this.selectedNode.data.RegionId &&
        c.value.MspRegionId !== this.selectedNode.data.MspRegionId &&
        !c.value.IsDistributor) {
        if (!customers_pick.includes(c.value.MspRegionId) || customers.includes(c.value.MspRegionId)) {
          this.customerOptions.push({
            label: c.label , value: c.value.MspRegionId
          });
        }
      }
    });

    this.customers = customers;
    this.dialogInput = {
      // DocType: this.selectedNode.data.DocType !== null ? this.selectedNode.data.DocType : 0,
      // DocDay: this.selectedNode.data.DocDay,
      RegionId: this.selectedNode.data.RegionId,
      IsDistributor: this.selectedNode.data.IsEndUser ? false : this.selectedNode.data.IsDistributor,
      IsCustomer: this.selectedNode.data.IsCustomer,
      IsEndUser: this.selectedNode.data.IsEndUser,
      Customers: customers,
      UnitPrice:  this.selectedNode.data.IsEndUser ? PrepaidUnitPrice : (this.selectedNode.data.UnitPrice !== undefined ? this.selectedNode.data.UnitPrice : 1),
      CompanyName: this.selectedNode.data.CompanyName,
      Address: this.selectedNode.data.Address,
      MinCharge: this.selectedNode.data.MinCharge !== undefined ? this.selectedNode.data.MinCharge : DefaultMinimumQuantity.Count,
      CompanyEmail: this.selectedNode.data.CompanyEmail,
      SyncSetting: false,
      IsNotSendReminder: !this.selectedNode.data.IsReminder,
      IsNotAllowLock: !this.selectedNode.data.IsAllowLock,
      NpmUsageType: this.selectedNode.data.MspRegionId === this.selectedNode.data.PaymentRegionId ? 1 : 0,
    };

    let editrecipientList = [];
    const emailInfo = Array.isArray(this.selectedNode.data.EmailInfo)
      ? this.selectedNode.data.EmailInfo
      : [];
    if (emailInfo.length !== 0) {
      editrecipientList = emailInfo.map((item, index) => {
        return { ...item, id: index + 1, Type: 0 };
      });
    }

    this.recipientList = editrecipientList;
    this.dialogVisibility.monthlyPayment = true;
  }

  onTabChange(event) {
    this.selectDefaultTab = event.index;
  }

  showAddRecipientDialog() {
    this.dialogRecipientInput = {
      Id: 0,
      UpdateType: 'Add Recipient',
      Receiver: '',
      ReceiverType: 0,
      Type: 0
    };

    this.dialogVisibility.recipient = true;
  }

  showEditRecipientDialog(rowData: EmailInfo) {
    this.dialogRecipientInput = {
      Id: rowData.id,
      UpdateType: 'Edit Recipient',
      Receiver: rowData.Receiver,
      ReceiverType: rowData.ReceiverType,
      Type: 1
    };

    this.dialogVisibility.recipient = true;
  }

  deleteRecipientData(rowData) {
    this.recipientList = this.recipientList.filter((i) => i.id !== rowData.id);
  }

  saveMonthlyPaymentMgt() {
    const recipient_main = [];
    const recipient_cc = [];
    const recipient_bcc = [];
    this.recipientList.map(info => {
      if (info.ReceiverType === planMailRecipientTypeName['MainRecipient']) {
        recipient_main.push(info.Receiver);
      } else if (info.ReceiverType === planMailRecipientTypeName['CC']) {
        recipient_cc.push(info.Receiver);
      } else if (info.ReceiverType === planMailRecipientTypeName['BCC']) {
        recipient_bcc.push(info.Receiver);
      }
    });
    this.recipient_main = recipient_main.join('/ ');
    this.recipient_cc = recipient_cc.join('/ ');
    this.recipient_bcc = recipient_bcc.join('/ ');
    this.dialogVisibility.confirm = true;
    this.dcoumentType_name = DocumentTypeName[0];
    if (!this.dialogInput.IsDistributor) {
      this.dialogInput.Customers = [];
    }
    if (this.dialogInput.Customers !== undefined) {
      const customers_name = [];
      this.dialogInput.Customers.map((c) => {
        if (this.regionDic[c] !== undefined) {
          customers_name.push(this.regionDic[c].RegionName);
        }
      });
      this.customers_str = customers_name.join('/ ');
    }
  }

  saveAddRecipient() {
    if (this.dialogRecipientInput.Type === 0) {
      this.recipientList = [...this.recipientList, {
        id: this.recipientList.length + 1,
        Type: 0,
        Receiver: this.dialogRecipientInput.Receiver,
        ReceiverType: this.dialogRecipientInput.ReceiverType
      }];
    } else if (this.dialogRecipientInput.Type === 1 && this.dialogRecipientInput.Id > 0) {
      const itemIndex = this.recipientList.findIndex((i) => i.id === this.dialogRecipientInput.Id);
      if (itemIndex >= 0) {
        this.recipientList[itemIndex] = {
          ...this.recipientList[itemIndex],
          Type: 0,
          Receiver: this.dialogRecipientInput.Receiver,
          ReceiverType: this.dialogRecipientInput.ReceiverType
        };
      }
    }
  }

  confirmMonthlyPayment() {
    this.ngxService.start();

    this.dialogVisibility.confirm = false;
    this.dialogVisibility.monthlyPayment = false;
    const data: MspPaymentSetting = {
      RegionId: this.selectedNode.data.MspRegionId,
      UnitPrice: this.dialogInput.UnitPrice,
      Company: this.dialogInput.CompanyName,
      Address: this.dialogInput.Address,
      EmailInfo: this.recipientList,
      // DocType: this.dialogInput.DocType,
      // DocDay: this.dialogInput.DocDay,
      IsDistributor: this.dialogInput.IsDistributor,
      Customers: this.dialogInput.Customers,
      MinCharge: this.dialogInput.MinCharge !== null  ? parseInt(this.dialogInput.MinCharge) : 0,
      CompanyEmail: this.dialogInput.CompanyEmail,
      SyncSetting: this.dialogInput.SyncSetting,
      IsReminder: !this.dialogInput.IsNotSendReminder,
      IsAllowLock: !this.dialogInput.IsNotAllowLock,
      PaymentRegionId: this.dialogInput.NpmUsageType === 0 ? this.selectedNode.data.DistributorId : this.selectedNode.data.MspRegionId
    };

    this.store.dispatch(new fromFeature.UpdateMspRegionPayment(data));
    this.selectedNode = null;

  }

  filter_region() {
    if (this.filterRegion.RegionIds.length > 0) {
      this.monthlyPaymentList = [];
      this.filterRegion.RegionIds.map((m) => {
        if (this.region_filter_Dic[m] !== undefined) {
          if (this.region_filter_Dic[m].length > 0) {
            this.region_filter_Dic[m].map((r) => {
              this.monthlyPaymentList.push(r);
            });
          } else {
            this.monthlyPaymentList.push(this.region_filter_Dic[m]);
          }
        }
      });
      this.monthlyPaymentList = [...this.monthlyPaymentList].sort((a, b) => {
        if (a.RegionId < b.RegionId) return -1;
        if (a.RegionId > b.RegionId) return 1;
        if (a.RegionId === b.RegionId) {
          if (new Date(a.DocumentCreateTime).getTime() > new Date(b.DocumentCreateTime).getTime()) return -1;
          if (new Date(a.DocumentCreateTime).getTime() < new Date(b.DocumentCreateTime).getTime()) return 1;
        }
        return 0;
      });
    } else {
      this.monthlyPaymentList = this.monthlyPaymentListStash;
    }
    this.getTreeRegionPayment();
  }

  replaceToFixed(e) {
    const inputElement = e.target;
    const value = inputElement.value;
    const regex = /^\d*\.?\d{0,2}$/;
    const isValid = regex.test(value);
    if (!isValid && value !== undefined) {
      this.dialogInput.UnitPrice = parseFloat(value).toFixed(2);
    }
  }

  onPanelShow() {
    this.inheritDialog = true;
  }

  onPanelHide() {
    this.inheritDialog = false;
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
    if (this.update_payment_flag && this.isSystemAdmin) {
      this.update_payment_flag = false;
      this.store.dispatch(new fromFeature.GetRegions());
    }
  }

  // 將資料轉換成TreeTable格式
  getTreeRegionPayment() {
    this.treeRegionPayment = this.monthlyPaymentList.map(i => ({
      data: {
        ...i
      },
      children: i.Customers.map(customer => ({
        data: {
          ...customer,
          Company: this.regionDic[customer.value.Id].RegionName
        }
      })),
      expanded: true
    })) as any[];
    this.treeRegionPaymentStash = this.treeRegionPayment;
    this.searchKeyWord();
  }

  searchKeyWord() {
    if (this.keyWord) {
      const keyword = this.keyWord.toLowerCase();
      this.treeRegionPayment = this.treeRegionPaymentStash
        .map(parent => {
          const matchParent = (parent.data.Company || '').toLowerCase().includes(keyword);
          const filteredChildren = (parent.children || []).filter(child =>
            (child.data.Company || '').toLowerCase().includes(keyword)
          );
          if (matchParent || filteredChildren.length > 0) {
            return {
              ...parent,
              children: matchParent ? parent.children : filteredChildren
            };
          }
          return null;
        })
        .filter(item => item !== null);
    } else {
      this.treeRegionPayment = this.treeRegionPaymentStash;
    }
  }

  filter_record() {
    this.paymentRecordListFiltered = this.paymentRecordList;
    if (this.filterRegion.RegionIdForRecord > 0) {
      this.paymentRecordListFiltered = this.paymentRecordListFiltered.filter(item => {
        return item.ParentRegionId === this.filterRegion.RegionIdForRecord;
      });
    }
    if (this.selectedCompany.length > 0) {
      this.paymentRecordListFiltered = this.paymentRecordListFiltered.filter(item => {
        return this.selectedCompany.some(option => option.value === item.Company);
      });
      
    }
    if (this.selectedYears.length > 0) {
      this.paymentRecordListFiltered = this.paymentRecordListFiltered.filter(item => {
        const year = parseInt(item.GenerateTime.slice(0, 4), 10);
        return this.selectedYears.some(option => option.value === year);
      });
    }
  }

  getDefaultDate() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const allYears = this.paymentRecordList.map(item =>
      parseInt(item.GenerateTime.slice(0, 4), 10)
    );

    // 去重並排序
    const uniqueYears = Array.from(new Set(allYears)).sort((a, b) => a - b);

    // 塞進 yearOptions
    this.yearOptions = uniqueYears.map(year => ({
      label: year.toString(),
      value: year,
    }));
  }

  onReminderToggle(event: any) {
    if (event.value === 0) {
      this.dialogInput.IsNotSendReminder = true;
      this.dialogInput.IsNotAllowLock = true;
    } else {
      this.dialogInput.IsNotSendReminder = false;
      this.dialogInput.IsNotAllowLock = false;
    }
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
